import actionTypes from '../actionTypes';

export function successLiveCasinoGames(data) {
  return {
    type: actionTypes.LIVECASINO_GAMES_SUCCESS,
    value: data,
  }
}

export function failLiveCasinoGames(e) {
  return {
    type: actionTypes.LIVECASINO_GAMES_FAIL,
    exception: e,
  }
}